// packages/content/src/tuning/chat.ts (M0-T19, rev 7 item 19) — chat bubble timing, the client log length and how long an emote's badge shows
import type { TuningBank } from '../schema/tuning';
export default { bubbleBaseMs: 3500, bubblePerCharMs: 45, bubbleMaxMs: 9000, logKeep: 100, emoteBadgeMs: 2600 } as const satisfies TuningBank;
